module.exports = __webpack_public_path__ + "static/media/bone4_Bitmap.9f2325a4.png";